import { useState } from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import SongCard from '../../components/base/SongCard';
import { initialSongs } from '../../mocks/songs';
import RadioLogo from '../../components/feature/RadioLogo';
import TwitterFeed from '../../components/feature/TwitterFeed';
import RadioSchedule from '../../components/feature/RadioSchedule';
import RadioStations from '../../components/feature/RadioStations';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [songs, setSongs] = useState(initialSongs);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  function handleDragEnd(event: DragEndEvent) {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      setSongs((items) => {
        const oldIndex = items.findIndex((item) => item.id === active.id);
        const newIndex = items.findIndex((item) => item.id === over.id);

        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-500 via-purple-600 to-blue-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative z-10">
        {/* Hero Section con Logo */}
        <div className="container mx-auto px-4 pt-8 pb-6">
          <div className="flex justify-center">
            <img 
              src="https://static.readdy.ai/image/65d660a72347d6d015a704c8d9d6c2d6/09e6a67b6a36dfe0e513df80b1d68cda.png" 
              alt="TOP 40 STAR" 
              className="w-full max-w-2xl h-auto rounded-2xl shadow-2xl"
            />
          </div>
        </div>

        {/* Radio Logo y Twitter Feed */}
        <div className="container mx-auto px-4 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <RadioLogo />
            <TwitterFeed />
          </div>
        </div>

        {/* Lista de Canciones */}
        <div className="container mx-auto px-4 pb-12">
          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 md:p-8 shadow-2xl border border-white/20">
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={songs.map(song => song.id)}
                strategy={verticalListSortingStrategy}
              >
                <div className="space-y-3">
                  {songs.map((song, index) => (
                    <SongCard key={song.id} song={song} position={index + 1} />
                  ))}
                </div>
              </SortableContext>
            </DndContext>
          </div>
        </div>

        {/* Programación y Emisoras */}
        <div className="container mx-auto px-4 pb-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <RadioSchedule />
            <RadioStations />
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}